import { render, staticRenderFns } from "./user-bar.vue?vue&type=template&id=26a19d3c"
import script from "./user-bar.vue?vue&type=script&lang=js"
export * from "./user-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports